module.exports = __webpack_public_path__ + "static/img/gou@2x.80aeea55.png";